import { Box, Paper, styled } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';

const InfoBannerTextContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '4px'
});

export const Info = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gridGap: 12,
  color: '#01294B',
  borderRadius: 8,
  padding: theme.spacing(2, 4),
  backgroundColor: '#EBF5FF',
  height: 56,

  '& svg': {
    transform: 'rotate(180deg)'
  }
}));

const InfoBanner = () => (
  <Paper
    variant="elevation"
    elevation={2}
    style={{ borderRadius: '8px', boxShadow: '0px 2px 4px 0px #30363C29' }}>
    <Info>
      <Box
        style={{
          background: '#037AE2',
          borderRadius: '50%',
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <ErrorOutlineRoundedIcon fontSize="small" style={{ color: '#fff' }} />
      </Box>
      <InfoBannerTextContainer>
        <SText title="Description:" weight="bold" size="sm" />
        <SText
          title="The initial matching process may take up to 5 - 10 mins"
          size="sm"
        />
      </InfoBannerTextContainer>
    </Info>
  </Paper>
);

export default InfoBanner;
